import React, { Component } from 'react'

import 'HELPDESK/Components/QueryDetails/AddRequestModal/addrequestmodal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DesignRequest from './DesignRequest/DesignRequest';
import ProductCustomization from './ProductCustomization/ProductCustomization';
import { toast } from 'react-toastify';

// import attachmentImage from "HELPDESK/CommonResources/images/attachment.png";

export class AddRequestModal extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        this.state = {
            openExecutiveResponse: this.props.openExecutiveResponse,
            customizationType: 'Enhancements',
            title: '',
            explanation: '',
            purpose: '',
            location: '',
            subModule: '',
            targetElement: '',
            customizationImpact: '',
            applicationType: '',
            currentFeatureUsage: '',
            desiredFeature: '',
            attachments: [],
            subModuleId: '',
            // create file fileInputRef
            // fileInputRef: React.createRef(),
            // create attachments state

            error: {
                title: '',
                explanation: '',
                purpose: '',
                location: '',
                subModule: '',
                targetElement: '',
                customizationImpact: '',
                applicationType: '',
                currentFeatureUsage: '',
                desiredFeature: '',
            },
            locationObjectArray: [],
            attachmentFileArray: [],
            selectedAttachment: [],
            filterOptions: [
                { label: "Filter", value: "filter" },
                { label: "Search Bar", value: "search_bar" },
                { label: "Column Show", value: "column_show" },
                { label: "Column Hide", value: "column_hide" },
                { label: "Input Field", value: "input_field" },
                { label: "Table", value: "table" },
                { label: "Graph Analysis", value: "graph_analysis" },
                { label: "Data List", value: "data_list" },
                { label: "Print Preview", value: "print_preview" },
                { label: "Export", value: "export" },
                { label: "Bulk Actions", value: "bulk_actions" },
                { label: "Forms", value: "forms" },
                { label: "Pagination", value: "pagination" },
                { label: "Attachments", value: "attachments" },
                { label: "Import", value: "import" },
                { label: "Bulk Update", value: "bulk_update" },
                { label: "Parameter", value: "parameter" }
            ],
            modulesFetching: false,
            moduleList: {},
            customizationFeature:  [
                    { customizationName: "Product Customization", value: <ProductCustomization /> },
                    { customizationName: "Design", value: <DesignRequest /> }
                ],
                // : [
                //     { customizationName: "Design", value: <DesignRequest /> }
                // ],
            currentCustomization: this.getInitialCustomization(),





        }
    }
    componentDidMount() {
        // Set the initial customization based on the selectedQueryType prop
        console.log("Component did mount - Selected Query Type:", this.props.selectedQueryType);
        console.log("asdfasd", this.state.openExecutiveResponse);
        console.log("Is Onboarded:", this.props.isOnboarded);
        console.log("Open Executive Response:", this.state.openExecutiveResponse);
        
        
    }
    getInitialCustomization() {
        const { selectedQueryType, isOnboarded } = this.props;

        console.log("Selected Query Type:", selectedQueryType);
        console.log("Is Onboarded:", isOnboarded);

        if (!isOnboarded) {
            return 'Design'; // or you can return a default value if needed
        }

        if (selectedQueryType === "errors" || selectedQueryType === "enhancements") {
            return "Product Customization";
        }
        if (selectedQueryType === "designs") {
            return "Design";
        }
        return "Product Customization";
    }
    handleCustomization = (currentCustomization) => {
        if (currentCustomization === "Product Customization" && !this.props.isOnboarded) {
            toast.warn("You are currently undergoing the onboarding process. Once you confirm that your onboarding is complete, you will be able to add requests.");
            return;
        }

        this.setState({ currentCustomization }); // Update state with the selected communication team
    };


    render() {
        return (
            <div className={this.state.openExecutiveResponse ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog executiveResponseModal">
                    <div className="modal-content executive-response-modal-content">
                        {/* Containing header Add Executive Response */}
                        <div className="modal-header executive-response-header">
                            <p className="vm_custom_h4">Service Request Test</p>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer', alignSelf: 'center', marginTop: '8px' }} size="md" color="#F9FAFB" onClick={() => this.props.onCloseModal()} />
                        </div>
                        <div className='typeOfCustomization'>

                            <div className="request-tabs">

                                {/* Case 1: No prop -> show all tabs */}
                                {!this.props.selectedQueryType &&
                                    this.state.customizationFeature.map((customization) => (
                                        <p
                                            key={customization.id}
                                            className={`vm_custom_subtitle5 request-tab ${customization.customizationName === this.state.currentCustomization
                                                ? "active"
                                                : ""
                                                }`}
                                            onClick={() =>
                                                this.handleCustomization(customization.customizationName)
                                            }
                                        >
                                            {customization.customizationName}
                                        </p>
                                    ))}

                                {/* Case 2: Prop = errors or enhancements -> show only Product Customization */}
                                {(this.props.selectedQueryType === "errors" ||
                                    this.props.selectedQueryType === "enhancements") && (
                                        <p
                                            className={`vm_custom_subtitle5 request-tab ${this.state.currentCustomization === "Product Customization"
                                                ? "active"
                                                : ""
                                                }`}
                                            onClick={this.props.isOnboarded ? () => this.handleCustomization("Product Customization") : () => toast.warn("Please complete the onboarding process to access this feature")}
                                        >
                                            Product Customization
                                        </p>
                                    )}

                                {/* Case 3: Prop = designs -> show only Design */}
                                {this.props.selectedQueryType === "designs" && (
                                    <p
                                        className={`vm_custom_subtitle5 request-tab ${this.state.currentCustomization === "Design" ? "active" : ""
                                            }`}
                                        onClick={() => this.handleCustomization("Design")}
                                    >
                                        Design
                                    </p>
                                )}

                            </div>
                            {/* Render Component base on selectedCommunicationTeam */}
                            <>
                                {
                                    this.state.currentCustomization === 'Product Customization' && <ProductCustomization
                                        // currentRequest={this.props.currentRequest}
                                        currentClientResponse={this.props.currentClientResponse}
                                        // currentQueryRequestId={this.state.currentQueryRequestId}
                                        selectedModuleName={this.props.selectedModuleName}
                                        selectedModuleId={this.props.selectedModuleId}
                                        onCloseModal={this.props.onCloseModal}
                                        selectedQueryType={this.props.selectedQueryType}

                                    />

                                }
                                {
                                    this.state.currentCustomization === 'Design' && <DesignRequest
                                        // currentRequest={this.props.currentRequest}
                                        currentClientResponse={this.props.currentClientResponse}
                                        // currentQueryRequestId={this.state.currentQueryRequestId}
                                        selectedModuleName={this.props.selectedModuleName}
                                        selectedModuleId={this.props.selectedModuleId}
                                        selectedQueryType={this.props.selectedQueryType}
                                        onCloseModal={this.props.onCloseModal}
                                    />

                                }

                            </>



                        </div>

                    </div>
                </div>

            </div>
        )
    }
}

export default AddRequestModal
